export default __webpack_public_path__ + "static/media/459.aed3cb56.jpg";